import React, { ReactElement, useContext } from 'react';
import Score from './Score';
import Club from './Club';
import { LiveMatchContext } from '../../context';

type WidgetResultsProps = {
  gameStage: string;
};

const WidgetResults = ({ gameStage }: WidgetResultsProps): ReactElement => {
  const {
    liveMatchData: { home, away, details }
  } = useContext(LiveMatchContext);
  const endWithPenalties = !!(gameStage === 'game-end' && details?.score?.penaltyScore);

  return (
    <div className={`widget-result ${endWithPenalties ? 'widget-result-penalty' : ''}`}>
      <Club name={home?.contestantName} icon={home?.teamLogoUrl} />
      <Score score={details?.score} gameStage={gameStage} endWithPenalties={endWithPenalties} />

      <Club name={away?.contestantName} icon={away?.teamLogoUrl} />
    </div>
  );
};

export default WidgetResults;
